import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CallToAction = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/cta-1.jpeg"
          alt="African professionals collaborating"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/90 via-brand-tertiary/85 to-brand-primary/90"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full animate-float"></div>
      <div
        className="absolute bottom-10 right-10 w-16 h-16 bg-white/10 rounded-full animate-float"
        style={{ animationDelay: "1s" }}
      ></div>
      <div
        className="absolute top-1/2 left-1/4 w-12 h-12 bg-white/10 rounded-full animate-float"
        style={{ animationDelay: "2s" }}
      ></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Join the African Excellence Movement
          </h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Partner with us to access Africa's top talent while creating
            meaningful employment opportunities. Together, we're building the
            future of work.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/contact"
              className="group bg-white/95 backdrop-blur-sm text-brand-primary px-8 py-4 rounded-2xl text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:bg-white"
            >
              <span className="flex items-center justify-center">
                Start Your Partnership
                <ArrowRight
                  className="ml-2 group-hover:translate-x-1 transition-transform"
                  size={20}
                />
              </span>
            </Link>
            <Link
              to="/portfolio"
              className="group border-2 border-white/80 text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-white/95 hover:backdrop-blur-sm hover:text-brand-primary transition-all duration-300 transform hover:-translate-y-1"
            >
              See Our Impact Stories
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
